import { createContext, useContext, useState } from "react";
import { getCookie, setCookie, clearAllCookies } from "../utils/cookie";


export const ROLES = {
  FLEET_OWNER: 3,
  CHECKER: 9,
  MAKER: 10,
};

export const USER_COOKIE = "cb_user";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => getCookie(USER_COOKIE));

  const login = (data) => {
    setCookie(USER_COOKIE, data);
    setUser(data);
  };

  const logout = () => {
    clearAllCookies();
    setUser(null);
  };

  const hasRole = (roles) => !roles || roles.includes(user?.roleID);

  return (
    <AuthContext.Provider value={{ user, login, logout, hasRole }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
